import React from 'react';
import SubmitCommonComponent from './SubmitCommonComponent';
import { SubmitProps, getNextFeedbackStatus, isNoFeedbackGiven } from './utils';

const subheading =
  'Thanks for providing all your feedback. Once you send your responses, we’ll notify the organization to view and resolve all your ' +
    'questions.';
const noFeedbackSubheading =
  'You have not provided any feedback. We can publish your report.';

type SubmitFeedbackProps = SubmitProps

const SubmitFeedback: React.FC<SubmitFeedbackProps> = ({
  total,
  feedbackStatus,
  feedbackType,
  userType,
  className,
  isLoading,
  errorMessage,
  onDone,
  handleBack,
}) => {
  const noFeedbackGiven = isNoFeedbackGiven(
    feedbackType,
    feedbackStatus,
    userType,
    total,
  );

  const onClick = () => {
    onDone(
      getNextFeedbackStatus(
        feedbackType,
        feedbackStatus,
        userType,
        false,
        total,
      ),
    );
  };

  return (
    <SubmitCommonComponent
      heading="Great job!"
      subheading={noFeedbackGiven ? noFeedbackSubheading : subheading}
      onClick={onClick}
      isLoading={isLoading}
      errorMessage={errorMessage}
      buttonText={noFeedbackGiven ? 'Publish' : 'Send feedback'}
      className={className}
      handleBack={handleBack}
    />
  );
};

export default SubmitFeedback;
